import {parsePhoneNumber, PhoneNumberParseOptions} from 'awesome-phonenumber'

export const formatPhoneNumber = (
  number: string | null | undefined,
  parseOptions?: PhoneNumberParseOptions,
  emptyString = '',
) => {
  if (!number) {
    return emptyString
  } else {
    const parsedNumber = parsePhoneNumber(number, parseOptions)
    if (!parsedNumber.valid) {
      return number
    } else {
      return parsedNumber.number.international
    }
  }
}

/*
 * Our displayed numbers wrap the country code - `(+421) 2 3345 6574` - which libphonenumber will
 * not parse. Unwrap it and the library handles the rest, including dropping national trunk
 * prefixes: `(+61) (08) 9106 9499` -> `+61891069499`, which is what you dial from abroad.
 */
export const displayedPhoneNumberToE164 = (displayed: string) =>
  getValidPhoneNumberE164(displayed.replace(/^\((\+\d+)\)/, '$1'))

export const getValidPhoneNumberE164 = (
  number: string | null | undefined,
  parseOptions?: PhoneNumberParseOptions,
): string | null => {
  if (!number) {
    return null
  }

  const parsedNumber = parsePhoneNumber(number, parseOptions)
  return parsedNumber.valid ? parsedNumber.number.e164 : null
}

// what we store: a valid number written as `+447946095800`
export const isValidE164PhoneNumber = (number: string) => getValidPhoneNumberE164(number) === number

/*
 * Phones saved before E.164 was required: a dial code alone (`+44`, what an emptied field saved)
 * is no number, and a valid international one (`+44 7946 095800`, `0044 …`) becomes E.164. A
 * national number is left as it is, since its country would only be a guess.
 */
export const normalizeStoredPhoneNumber = (value: string) => {
  if (/^\+\d{0,4}$/.test(value)) {
    return ''
  }
  const international = value.trim().replace(/^00/, '+')
  return international.startsWith('+') ? getValidPhoneNumberE164(international) ?? value : value
}
